
import { WorldCountry } from '../types';

export const indonesiaExpanded4: WorldCountry = {
  code: 'ID',
  name: 'Indonesia',
  slug: 'indonesia',
  population: 273800000,
  topCities: [
    // Ciudades principales existentes
    { name: 'Jakarta', slug: 'jakarta', population: 10770487 },
    { name: 'Surabaya', slug: 'surabaya', population: 2874699 },
    { name: 'Bandung', slug: 'bandung', population: 2444160 },
    { name: 'Bekasi', slug: 'bekasi', population: 2543676 },
    { name: 'Medan', slug: 'medan', population: 2435252 },
    { name: 'Depok', slug: 'depok', population: 2056335 },
    { name: 'Tangerang', slug: 'tangerang', population: 1895486 },
    { name: 'Palembang', slug: 'palembang', population: 1668848 },
    { name: 'Semarang', slug: 'semarang', population: 1653524 },
    { name: 'Makassar', slug: 'makassar', population: 1423877 },
    
    // Ciudades adicionales para llegar a 100+
    { name: 'South Tangerang', slug: 'south-tangerang', population: 1365688 },
    { name: 'Batam', slug: 'batam', population: 1196396 },
    { name: 'Bogor', slug: 'bogor', population: 1043070 },
    { name: 'Pekanbaru', slug: 'pekanbaru', population: 983356 },
    { name: 'Bandar Lampung', slug: 'bandar-lampung', population: 881801 },
    { name: 'Padang', slug: 'padang', population: 833562 },
    { name: 'Malang', slug: 'malang', population: 820243 },
    { name: 'Denpasar', slug: 'denpasar', population: 725314 },
    { name: 'Samarinda', slug: 'samarinda', population: 727500 },
    { name: 'Tasikmalaya', slug: 'tasikmalaya', population: 678357 },
    { name: 'Serang', slug: 'serang', population: 692101 },
    { name: 'Balikpapan', slug: 'balikpapan', population: 688318 },
    { name: 'Banjarmasin', slug: 'banjarmasin', population: 625481 },
    { name: 'Yogyakarta', slug: 'yogyakarta', population: 373589 },
    { name: 'Surakarta', slug: 'surakarta', population: 499337 },
    { name: 'Jambi', slug: 'jambi', population: 606200 },
    { name: 'Cimahi', slug: 'cimahi', population: 568400 },
    { name: 'Mataram', slug: 'mataram', population: 441954 },
    { name: 'Pontianak', slug: 'pontianak', population: 658685 },
    { name: 'Manado', slug: 'manado', population: 451893 },
    { name: 'Kupang', slug: 'kupang', population: 442758 },
    { name: 'Bengkulu', slug: 'bengkulu', population: 373096 },
    { name: 'Palu', slug: 'palu', population: 373218 },
    { name: 'Kendari', slug: 'kendari', population: 345107 },
    { name: 'Jayapura', slug: 'jayapura', population: 398478 },
    { name: 'Sukabumi', slug: 'sukabumi', population: 314371 },
    { name: 'Cirebon', slug: 'cirebon', population: 296389 },
    { name: 'Banda Aceh', slug: 'banda-aceh', population: 223446 },
    { name: 'Binjai', slug: 'binjai', population: 181904 },
    { name: 'Lhokseumawe', slug: 'lhokseumawe', population: 188713 },
    { name: 'Langsa', slug: 'langsa', population: 185971 },
    { name: 'Sabang', slug: 'sabang', population: 43117 },
    { name: 'Subulussalam', slug: 'subulussalam', population: 67446 },
    { name: 'Tebing Tinggi', slug: 'tebing-tinggi', population: 172838 },
    { name: 'Pematangsiantar', slug: 'pematangsiantar', population: 268254 },
    { name: 'Tanjungbalai', slug: 'tanjungbalai', population: 154445 },
    { name: 'Sibolga', slug: 'sibolga', population: 91307 },
    { name: 'Gunungsitoli', slug: 'gunungsitoli', population: 126202 },
    { name: 'Padangsidimpuan', slug: 'padangsidimpuan', population: 225105 },
    { name: 'Bukittinggi', slug: 'bukittinggi', population: 111312 },
    { name: 'Payakumbuh', slug: 'payakumbuh', population: 116825 },
    { name: 'Pariaman', slug: 'pariaman', population: 94224 },
    { name: 'Solok', slug: 'solok', population: 64348 },
    { name: 'Sawahlunto', slug: 'sawahlunto', population: 56866 },
    { name: 'Padangpanjang', slug: 'padangpanjang', population: 47008 },
    { name: 'Dumai', slug: 'dumai', population: 316782 },
    { name: 'Tanjung Pinang', slug: 'tanjung-pinang', population: 227663 },
    { name: 'Tembilahan', slug: 'tembilahan', population: 63648 },
    { name: 'Bangko', slug: 'bangko', population: 27637 },
    { name: 'Sungai Penuh', slug: 'sungai-penuh', population: 96610 },
    { name: 'Muaro Jambi', slug: 'muaro-jambi', population: 82500 },
    { name: 'Lubuklinggau', slug: 'lubuklinggau', population: 234166 },
    { name: 'Prabumulih', slug: 'prabumulih', population: 176196 },
    { name: 'Pagaralam', slug: 'pagaralam', population: 143166 },
    { name: 'Metro', slug: 'metro', population: 158454 },
    { name: 'Pangkalpinang', slug: 'pangkalpinang', population: 174838 },
    { name: 'Cilegon', slug: 'cilegon', population: 374464 },
    { name: 'Karawang', slug: 'karawang', population: 307880 },
    { name: 'Purwakarta', slug: 'purwakarta', population: 114068 },
    { name: 'Subang', slug: 'subang', population: 126157 },
    { name: 'Indramayu', slug: 'indramayu', population: 138440 },
    { name: 'Kuningan', slug: 'kuningan', population: 104344 },
    { name: 'Majalengka', slug: 'majalengka', population: 166473 },
    { name: 'Sumedang', slug: 'sumedang', population: 117199 },
    { name: 'Ciamis', slug: 'ciamis', population: 128097 },
    { name: 'Banjar', slug: 'banjar', population: 179764 },
    { name: 'Garut', slug: 'garut', population: 267831 },
    { name: 'Cianjur', slug: 'cianjur', population: 175654 },
    { name: 'Purwokerto', slug: 'purwokerto', population: 233951 },
    { name: 'Magelang', slug: 'magelang', population: 121526 },
    { name: 'Klaten', slug: 'klaten', population: 121075 },
    { name: 'Wonogiri', slug: 'wonogiri', population: 91592 },
    { name: 'Karanganyar', slug: 'karanganyar', population: 94194 },
    { name: 'Sragen', slug: 'sragen', population: 876690 },
    { name: 'Boyolali', slug: 'boyolali', population: 980102 },
    { name: 'Sukoharjo', slug: 'sukoharjo', population: 876690 },
    { name: 'Tegal', slug: 'tegal', population: 273825 },
    { name: 'Pekalongan', slug: 'pekalongan', population: 319378 },
    { name: 'Purbalingga', slug: 'purbalingga', population: 90479 },
    { name: 'Banyumas', slug: 'banyumas', population: 176918 },
    { name: 'Cilacap', slug: 'cilacap', population: 103956 },
    { name: 'Kebumen', slug: 'kebumen', population: 129046 },
    { name: 'Wonosobo', slug: 'wonosobo', population: 83664 },
    { name: 'Temanggung', slug: 'temanggung', population: 109534 },
    { name: 'Kendal', slug: 'kendal', population: 101976 },
    { name: 'Demak', slug: 'demak', population: 106300 },
    { name: 'Kudus', slug: 'kudus', population: 92753 },
    { name: 'Jepara', slug: 'jepara', population: 92899 },
    { name: 'Pati', slug: 'pati', population: 123792 },
    { name: 'Rembang', slug: 'rembang', population: 64621 },
    { name: 'Blora', slug: 'blora', population: 82985 },
    { name: 'Grobogan', slug: 'grobogan', population: 143205 },
    { name: 'Batu', slug: 'batu', population: 213046 },
    { name: 'Blitar', slug: 'blitar', population: 137880 },
    { name: 'Probolinggo', slug: 'probolinggo', population: 233486 },
    { name: 'Pasuruan', slug: 'pasuruan', population: 198628 },
    { name: 'Mojokerto', slug: 'mojokerto', population: 132434 },
    { name: 'Madiun', slug: 'madiun', population: 174590 },
    { name: 'Kediri', slug: 'kediri', population: 268950 }
  ]
};
